
import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCButton, RCIcon } from '@reverbdotcom/cadence/components';
import { ChevronRightIcon, ChevronLeftIcon, AngleRightIcon } from '@reverbdotcom/cadence/icons/react';
import ModalDialog from '@reverbdotcom/commons/src/components/modal_dialog';

import TransactionTable, { IPriceRecord } from '../../../../price_guide_tool/csp_module/shared/transaction_table';

export const PAGE_SIZE = 10;
export const MAX_PAGES = 10;

interface IProps {
  priceRecords: IPriceRecord[];
  offset: number;
  total: number;
  refetch: (offset: number) => void;
  headerTitle: string;
  buttonText: string;
  dateHeader?: string;
  priceHeader?: string;
}

export function SellFormPricingModal({
  priceRecords,
  offset,
  total,
  refetch,
  buttonText,
  headerTitle,
  dateHeader = undefined,
  priceHeader = undefined,
}: IProps) {
  const [isOpen, setIsOpen] = useState(false);

  const currentPage = offset / PAGE_SIZE;
  const totalPages = Math.floor(total / PAGE_SIZE);
  const disableNextPageButton = (currentPage + 1) >= Math.min(totalPages, MAX_PAGES);

  function onPageChange(pageChange: number) {
    return () => {
      const newPage = currentPage + pageChange;
      const newOffset = newPage * PAGE_SIZE;

      refetch(newOffset);
    };
  }

  if (!total) { return null; }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="weight-bold button-as-link color-primary"
      >
        <span>
          {buttonText}
        </span>
        <RCIcon svgComponent={AngleRightIcon} inline />
      </button>
      <ModalDialog
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        onSubmit={() => setIsOpen(false)}
        headerTitle={headerTitle}
        saveButtonText={I18n.t('discovery.sellForm.pricingSection.pricingTables.close')}
        hideFooterDismissButton
      >
        <div>
          <TransactionTable
            priceRecords={priceRecords}
            dateHeader={dateHeader}
            priceHeader={priceHeader}
          />
        </div>

        {totalPages > 1 && (
          <nav
            aria-label={I18n.t('discovery.sellForm.pricingSection.pricingTables.nav')}
            className="d-flex fx-dir-row fx-justify-end mt-1"
          >
            <RCButton
              size="small"
              onClick={onPageChange(-1)}
              title={I18n.t('discovery.sellForm.pricingSection.pricingTables.previous')}
              disabled={currentPage === 0}
            >
              <RCIcon
                svgComponent={ChevronLeftIcon}
                inline
              />
            </RCButton>

            <div className="ml-half">
              <RCButton
                size="small"
                onClick={onPageChange(1)}
                title={I18n.t('discovery.sellForm.pricingSection.pricingTables.next')}
                disabled={disableNextPageButton}
              >
                <RCIcon
                  svgComponent={ChevronRightIcon}
                  inline
                />
              </RCButton>
            </div>

          </nav>
        )}

        <p className="mt-4 color-secondary">
          {I18n.t('discovery.sellForm.pricingSection.pricingTables.disclaimer')}
        </p>
      </ModalDialog>
    </>
  );
}
